export const DriverViewConfig: DriverViewConfig = {
  title: "Drivers",
  cards: [
    {
      title: "Personal Details",
      type: "driver",
      userId: "",
      status: "Active",
      fields: [
        {
          label: "Name",
          value: "NA",
          type: "text",
          key: "name",
          isVisible: false
        },
        {
          label: "Phone",
          value: "NA",
          type: "text",
          key: "phoneNumber",
          isVisible: true
        },
        {
          label: "Email",
          value: "NA",
          type: "text",
          key: "email",
          isVisible: true
        },
        {
          label: "Phone",
          value: "NA",
          type: "text",
          key: "emergencyNo",
          isVisible: false
        },
        {
          label: "RFID",
          value: "NA",
          type: "text",
          key: "rfidStatus",
          isVisible: false
        },
        {
          label: "RFID No",
          value: "NA",
          type: "text",
          key: "rfid",
          isVisible: false
        },
        {
          label: "Date of Birth",
          value: "NA",
          type: "text",
          key: "dob",
          isVisible: true
        },
        {
          label: "End Date",
          value: "NA",
          type: "text",
          key: "name",
          isVisible: false
        },
        {
          label: "Facility",
          value: "NA",
          type: "text",
          key: "facility",
          isVisible: false
        },
        {
          label: "Employment Type",
          value: "NA",
          type: "text",
          key: "employmentType",
          isVisible: false
        },
        {
          label: "Operator",
          value: "NA",
          type: "text",
          key: "operatorId",
          isVisible: false
        },
        {
          label: "Vendor ID",
          value: "NA",
          type: "text",
          key: "vendorId",
          isVisible: false
        },
        {
          label: "Status",
          value: "NA",
          type: "text",
          key: "status",
          isVisible: false
        },
        {
          label: "License No",
          value: "NA",
          type: "text",
          key: "licenceNo",
          isVisible: false
        },
        {
          label: "Image",
          value: "NA",
          type: "text",
          key: "driverPhoto",
          isVisible: false
        },
        {
          label: "Vehicle",
          value: "NA",
          type: "text",
          key: "trackerName",
          isVisible: false
        }
      ]
    },
    {
      title: "Compliance Details",
      type: "compliance",
      fields: [
        {
          label: "License No",
          value: "NA",
          type: "text",
          key: "licenseNumber",
          isVisible: true
        },
        {
          label: "Licence Expiry",
          value: "NA",
          type: "text",
          key: "licenseValidityDate",
          isVisible: true
        },
        {
          label: "Badge No",
          value: "NA",
          type: "text",
          key: "badgeNo",
          isVisible: false
        },
        {
          label: "Aadhar No",
          value: "NA",
          type: "text",
          key: "aadharNo",
          isVisible: false
        },
        {
          label: "Medical Test Expiry",
          value: "NA",
          type: "date",
          key: "medTestExpiry",
          isVisible: false
        },
        {
          label: "DDT Certificate No",
          value: "NA",
          type: "text",
          key: "ddtCertNo",
          isVisible: false
        },
        {
          label: "DDT Expiry",
          value: "NA",
          type: "date",
          key: "ddtExpiry",
          isVisible: false
        },
        {
          label: "BGV Status",
          value: "NA",
          type: "text",
          key: "bgv",
          isVisible: false
        },
        {
          label: "BGV Completed on",
          value: "NA",
          type: "date",
          key: "bgvComplDate",
          isVisible: false
        },
        {
          label: "Induction Status",
          value: "NA",
          type: "text",
          key: "induction",
          isVisible: false
        },
        {
          label: "Induction Completed on",
          value: "NA",
          type: "date",
          key: "inductionDate",
          isVisible: false
        }
      ]
    },
    {
      title: "Assigned Vehicles",
      type: "vehicleDetails",
      fields: [
        {
          label: "Vehicle",
          value: "NA",
          type: "text",
          key: "trackerName",
          isVisible: true
        },
        {
          label: "trackerId",
          value: "NA",
          type: "text",
          key: "trackerId",
          isVisible: false
        }
      ]
    },
    {
      title: "License Documents",
      type: "licenseDocuments",
      fields: [
        {
          label: "",
          value: "NA",
          type: "array",
          key: "licenseDocuments",
          isVisible: true
        }
      ]
    },
    {
      title: "Other Documents",
      type: "otherDocuments",
      fields: [
        {
          label: "",
          value: "NA",
          type: "array",
          key: "otherDocuments",
          isVisible: true
        }
      ]
    }
  ]
};
